var map = {
	"./Aerospace Science.jpg": "732a",
	"./Agroforestry & Food.jpg": "b779",
	"./Amynology.jpg": "56f4",
	"./Biology.jpg": "c07b",
	"./Bioscience & Biotechnology.jpg": "b06f",
	"./Chemical Science.jpg": "a68b",
	"./Computing.jpg": "04c4",
	"./Earth Science.jpg": "d4c4",
	"./Engineering Science.jpg": "1f83",
	"./Environmental Science.jpg": "d3ad",
	"./Flora & Fauna Science.jpg": "2799",
	"./HCP-Qu3_22.jpg": "3c63",
	"./Interdisciplinary.jpg": "e131",
	"./Managment, Economics & Finance.jpg": "8f14",
	"./Math & Quantitative Science.jpg": "cf68",
	"./Medical Science.jpg": "7f05",
	"./Molecular Genetics.jpg": "7149",
	"./Neuroscience & Neuropsychiatry.jpg": "15d9",
	"./Pharmaceutics & Toxicology.jpg": "92cb",
	"./Physical Science.jpg": "8ebb",
	"./Psychological Science.jpg": "6bd3",
	"./Resources & Materials Allocation.jpg": "85c0",
	"./Social Sciences.jpg": "c366",
	"./bg2-4.jpg": "e9d8",
	"./bg2-5.jpg": "448a",
	"./contact_03.jpg": "1daa",
	"./index-bg3.jpg": "b0e5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b5a1";